import React from "react";
import { motion } from "framer-motion";
import { ProjectsData } from "../../Assets/resource/uiux-project";
import Me from "../../Assets/Img/me2.png";

export default function UIUX() {
  return (
    <div className="text-white overflow-x-hidden">
      {/* ================= NAVBAR ================= */}
      <header
        id="#"
        className="fixed items-center gap-1.5 top-4 md:top-8 left-0 w-full z-50 flex justify-center z-[500]"
      >
        <div className="md:w-[36%] w-[95%] bg-black/20 backdrop-blur-md border border-white/10 shadow-lg rounded-full px-3 md:px-8 py-3 flex items-center justify-between">
          <a href="#" className="text-md md:text-lg font-semibold">
            Amir
          </a>

          <nav className="flex gap-2 md:gap-7 text-[12px] md:text-[14px]">
            {/* <a href="#">Home</a> */}
            <a href="#About" className="hover:text-[#C3FF38]">
              About
            </a>
            <a href="#Work" className="hover:text-[#C3FF38]">
              Work [50+]
            </a>
            <a href="#Process" className="hover:text-[#C3FF38]">
              Process
            </a>
            <a href="#Contact" className="hover:text-[#C3FF38]">
              Contact
            </a>
          </nav>
        </div>

        {/* <a
          href="https://drive.google.com/file/d/1_a1sAmDyzh92N-lVRwcVNr_T4fx5wQ3R/view?usp=drive_link"
          target="_blank"
          className="text-sm bg-[#C3FF38] text-black px-8 py-3.5 rounded-full transition-transform duration-500 ease-out origin-left hover:bg-white hover:scale-x-100 transition-colors"
        >
          Resume
        </a> */}
        <a
          href="https://drive.google.com/file/d/1_a1sAmDyzh92N-lVRwcVNr_T4fx5wQ3R/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          className="group relative inline-block overflow-hidden rounded-full px-4 md:px-8 py-3.5 text-[12px] md:text-sm font-medium bg-[#C3FF38] transition-transform md:block hidden"
        >
          {/* Sliding White Background */}
          <span className="absolute inset-0 bg-white scale-x-0 origin-left transition-transform duration-700 ease-[cubic-bezier(.19,1,.22,1)] group-hover:scale-x-100"></span>

          {/* Text */}
          <span className="relative z-10 text-black">Resume</span>
        </a>
      </header>

      {/* ================= HERO ================= */}
      <section className="md:w-[90%] w-[95%] mx-auto pt-[150px] pb-[40px] md:pb-[160px]">
        <div className="flex justify-between md:grid grid-cols-2">
          <div className="z-[50]">
            <h5 className="TAG text-[24px] md:text-[32px] font-bold text-white/90">
              Your Next UI/UX
            </h5>

            <h2 className="text-[80px] md:text-[170px] leading-[.9] font-bold">
              Design <br /> Engineer
            </h2>

            <p className="text-[18px] md:text-[20px]  font-normal w-[100%] md:w-[95%] mt-[40px] md:mt-[52px] leading-[1.3] z-[50]">
              <span className="text-white/50">
                I believe good design starts with understanding people — their
                frustrations, needs, and everyday experiences.
              </span>
              <span className="text-white/90">
                I help ideas into products that actually improve how people
                feel, work, and connect.
              </span>
              {/* My work focuses on converting real challenges into smooth experiences digital products that feel simple, useful, and natural to use. */}
            </p>

            {/* <a className="group text-[18px] font-medium wider cursor-pointer transform transition-transform duration-300 group-hover:scale-105 inline-block mt-7 flex items-center gap-1 ">
              <span className="group-hover:bg-white bg-[#C3FF38] rounded-full text-black px-12 py-3">
                Hire Me
              </span>

              <span className="bg-white group-hover:bg-[#25D366] group-hover:text-white rounded-full text-black px-3 py-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                  />
                </svg>
              </span>
            </a> */}

            <a
              href="https://wa.me/8801314600405"
              target="_blank"
              className="group relative inline-flex items-center gap-1 mt-6 cursor-pointer"
            >
              {/* Hire Me Button */}
              <span className="relative overflow-hidden rounded-full px-12 py-3 bg-[#C3FF38]">
                {/* Animated BG */}
                <span className="absolute inset-0 bg-white scale-x-0 origin-left transition-transform duration-500 ease-out group-hover:scale-x-100"></span>

                {/* Text */}
                <span className="relative z-10 text-black group-hover:text-black transition-colors duration-300 text-[18px] font-medium">
                  Hire Me
                </span>
              </span>

              {/* WhatsApp Button */}
              <span className="relative overflow-hidden rounded-full px-3 py-3 bg-white text-black transition-colors duration-300 group-hover:bg-[#25D366] group-hover:text-white ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill=""
                    d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                  />
                </svg>
              </span>
            </a>
          </div>
          <div className="relative ">
            <div className="w-[100%] h-[580px]">
              <img
                className="w-[100%] h-[580px]"
                src={Me}
                alt="profile image"
              />
            </div>
            <div className="flex blur-[78px] mt-[-150px] mr-[-180px] rotate-[-17deg]">
              <div className="w-[450px] h-[270px] bg-[#1DC4F3]"></div>
              <div className="w-[550px] h-[270px] blur-[50] bg-[#1DC4F3]"></div>
            </div>
          </div>
        </div>
        {/* <a className='bg-white mt-6 inline-block w-[48px] h-[48px] rounded-full' href="tel:+8801314600405" target="_blank">
          
        </a> */}
      </section>

      <div className=" mt-[-200px] z-[-100] blur-[50px]">
        {/* <div className="w-[100%] h-[180px] bg-[#1DC4F3]  blur-[160px] z-[-50]"></div>
        <div className="w-[100%] h-[180px] bg-[#C3FF38] mt-[-200px] blur-[160px] z-[-50]"></div> */}
        <div className="w-[400] h-[180px] bg-[#1DC4F3]  blur-[160px] z-[-50]"></div>
      </div>
      <div className="w-[99.9%] mt-[-160px] h-[60px] md:h-[80px] bg-orange-500 z-[200] absolute flex items-center justify-center gap-[8px] md:gap-[24px] rotate-[-2deg] overflow-hidden ">
        <h5 className="text-[20px] md:text-[48px] font-semibold] tracking-tight">UX/UI</h5>
        <h5 className="text-[20px] md:text-[48px] font-semibold] tracking-tight">✹</h5>
        <h5 className="text-[20px] md:text-[48px] font-semibold] tracking-tight">SAAS</h5>
        <h5 className="text-[20px] md:text-[48px] font-semibold] tracking-tight ">✹</h5>
        <h5 className="text-[20px] md:text-[48px] font-semibold] tracking-tight ">MVP</h5>
        <h5 className="text-[20px] md:text-[48px] font-semibold] tracking-tight">✹</h5>
        <h5 className="text-[20px] md:text-[48px] font-semibold] tracking-tight">AI</h5>
        <h5 className="text-[20px] md:text-[48px] font-semibold] tracking-tight hidden md:block ">✹</h5>
        <h5 className="hidden md:block text-[20px] md:text-[48px] font-semibold] tracking-tight">Web App</h5>
        <h5 className="text-[20px] md:text-[48px] font-semibold] tracking-tight hidden md:block ">✹</h5>
        <h5 className="hidden md:block text-[20px] md:text-[48px] font-semibold] tracking-tight">
          Mobile App
        </h5>
      </div>

      <section
        id="About"
        className="mt-[20px] md:mt-[80px] w-[90%] mx-auto pb-[80px] md:pb-[120px] z-[100]"
      >
        <h4 className="ml-4">ABOUT ME</h4>
        <div className="w-full mb-[-64px] h-[1px] bg-white/20 mt-[12px]"></div>

        <div className="flex justify between">
          <div className="w-[1px] h-[1200px] md:h-[880px] bg-white/20 mt-[-40px]"></div>
          <div className="mt-[40px] ml-[20px] mr-[20px]">
            <h5 className="text-[22px] text-white/100 font-regular w-[80%] md:w-[50%] mt-[52px] leading-[1.2]">
              I'm{" "}
              <span className="SERIF text-[24px] font-medium">
                @Amir Hosen,
              </span>{" "}
              a UX/UI Designer with over 1+ year of experience, working
              collaborative teams and completing 50+ real-world projects.
            </h5>

            <h4 className="mt-[48px] text-[40px] md:text-[68px] font-medium leading-[1.1]">
              From Idea to{" "}
              <span className="SERIF">
                MVP, <br className='md:block hidden'/> Design Products
              </span>{" "}
              that <br /> solve real problems.
            </h4>

            <div className="mt-[48px] md:flex justify-between items-start">
              <div>
                <h4 className="inline-block px-[16px] py-[8px] bg-white rounded-full text-black text-center flex gap-2 itmes-center justify-center md:mb-0 mb-4">
                  Experiences <span className='md:rotate-[0deg] rotate-[90deg]'>👉</span>
                </h4>
                {/* <div className="w-[70%] mt-2 h-[1px] bg-white/20"></div> */}
              </div>

              <div className="flex md:flex-row flex-col md:gap-[8px] gap-4 md:items-start">
                <div className="flex gap-12 bg-[#CF1DF3] backdrop-blur-md border text-black border-white/10 shadow-lg rounded-xl px-4 py-6">
                  <div>
                    <h5 className="font-medium text-[24px] pt-[28px] leading-[1.2] pb-4">
                      UI/UX Designer - <br /> Full-time
                    </h5>
                    <h6 className="font-medium">Pxlhut</h6>
                    <h6 className="text-sm text-gray/80">Nov 2025 - present</h6>
                  </div>
                </div>

                <div className="flex md:mt-[-180px] gap-12 bg-[1A9CCE] bg-[#1DC4F3] backdrop-blur-md border border-white/10 text-black shadow-lg rounded-xl px-6 py-4">
                  <div>
                    <h5 className="font-medium text-[24px] pt-[28px] leading-[1.2] pb-4">
                      UI/UX Designer - <br /> Intern
                    </h5>
                    <h6 className="font-medium">Qwik IT</h6>
                    <h6 className="text-sm text-gray/80">
                      Sep 2025 - Oct 2025
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[1px] h-[1200px] md:h-[880px] bg-white/20 mt-[-40px]"></div>
        </div>

        <div className="w-full h-[1px] bg-white/20 mt-[-20px] md:mt-[-80px]"></div>
      </section>

      <section id="Work" className="md:w-[90%] w-[95%] mx-auto pb-[120px] pt-[40px]">
        <h4 className="text-[44px] md:w-[70%] leading-[1.1] font-regular">
          Selected projects where real <br className='md:block hidden'/> problems met{" "}
          <span className="SERIF">thoughtful design solutions</span>
        </h4>
        <a
          href="/project/development"
          target="_blank"
          className="mt-[32px] font-light text-[12px] md:text-[16px] inline-block cursor-pointer bg-[#C3FF38]/90 text-black px-[4px] inline-flex"
        >
          href="
          <span className="font-[450]">I can also Code! You can Overview My Frontend Development Skills
            here</span>"
          <span className="md:inline-block ml-[20px] mr-[12px]">
            target="_blank"
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className="rotate-[45deg] text-black"
          >
            <path
              fill="#000"
              stroke="#000"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M12 5v14m6-8l-6-6m-6 6l6-6"
            />
          </svg>
        </a>

        {/*======================PROJECTS SHOWNG============= */}
        <div
          id="projects"
          className="mt-[68px] w-[95%] mx-auto my-8 grid md:grid-cols-2 gap-x-6 md:gap-x-8 gap-y-[48px] grid-cols-1"
        >
          {/* {/*----single project 4----- */}
          {/* {console.log(filterProject.length)} */}
          {ProjectsData?.map((p) => (
            <div className="group w-full h-[320px] md:h-[440px] text-[#DEDEDE] inline-block project-container relative text-[#9F9FA8] overflow-hidden">
              {/* border-[#28282b] hover:bg-gradient-to-tl from-[#0f172a]/60 to-[#1E3A8A]/60 bg-gradient-to-r from-slate-500/10 hover:bg-gradient-to-r from-slate-500/10 inline-block to-slate-500/20 via-slate-500/20  inline-block to-slate-500/20 via-slate-500/20 hover:border-[#1E3A8A]/40 hover:shadow hover:shadow-[#1E3A8A]/90*/}
              <img
                className="w-full h-[320px] md:h-[440px] shadow-xl transform transition-transform duration-300 group-hover:scale-105  object-cover"
                src={p.img}
                alt="Project"
              />

              <div className="project-overlay absolute inset-0 bg-black/80 text-white flex flex-col items-left justify-left opacity-0 hover:opacity-100 transition-opacity duration-300 cursor-pointer">
                <div className="mt-auto mb-[40px] ml-[12px] md:ml-[40px]">
                  <div className="text-[14px] mt-8 text-gray-200 font-regular uppercase ">
                    {p.category == "uiux" && "UX  ✹  UI"}
                  </div>
                  <a href={p.liveLink} target="_blank">
                    <h3
                      title={p.title}
                      className="text-[24px] md:text-[32px] mt-[12px] mb-[16px] font-regular text-[#f1f1f1] hover:text-blue-500 line-clamp-1 leading-[1.2] px-1 md:px-0"
                    >
                      {p.title}
                    </h3>
                  </a>
                  <div>
                    <ol className="text-[15px] text-left block text-white/90">
                      <li className="block text-left line-clamp-2 w-[70%] px-1 md:px-0 -leading-1.5">
                        {p.description}
                      </li>
                    </ol>

                    {/*------PROJECT LIVE LINKS BUTTONS----- */}
                    {/*------PROJECT LIVE LINKS BUTTONS----- */}
                    <div className="gap-2 md:mt-4 mt-8 px-1 md:px-0 pb-2 md:pb-0 flex w-full">
                      {p.liveLink && (
                        <a
                          href={p.liveLink}
                          target="_blank"
                          className="flex justify-center items-center gap-3 md:pl-6 md:pr-4 pl-[20px] pr-[16px] py-3 bg-[#C3FF38] hover:scale-105 duration-300 text-black rounded-2xl border border-slate-700 inline-block border-violet-400/20  text-[16px] md:text-[16px] text-center "
                        >
                          {/* bg-gradient-to-b to-[#0f1916] from-[#263435] hover:from-blue-600/80 hover:to-blue-800/90 */}
                          <span className="">
                            {p.category == "uiux"
                              ? "Figma Design"
                              : "Live Visit"}
                          </span>
                          {/* <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24"><path fill="currentColor" d="M11.667 2H8.333a3.333 3.333 0 1 0 0 6.667h3.334z" opacity="0.6"/><path fill="currentColor" d="M11.667 8.667H8.333a3.333 3.333 0 0 0 0 6.666h3.334z" opacity="0.4"/><path fill="currentColor" d="M18.333 12a3.333 3.333 0 1 1-6.667 0a3.333 3.333 0 0 1 6.667 0"/><path fill="currentColor" d="M8.333 15.334h3.334v3.333a3.333 3.333 0 1 1-3.334-3.334" opacity="0.2"/><path fill="currentColor" d="M11.666 2h3.333a3.333 3.333 0 1 1 0 6.667h-3.333z" opacity="0.8"/></svg> */}
                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 32 32"><path fill="#f4511e" d="M12 4h4v8h-4a4 4 0 0 1-4-4a4 4 0 0 1 4-4"/><path fill="#ff8a65" d="M20 12h-4V4h4a4 4 0 0 1 4 4a4 4 0 0 1-4 4"/><rect width="8" height="8" x="16" y="12" fill="#29b6f6" rx="4" transform="rotate(180 20 16)"/><path fill="#7c4dff" d="M12 12h4v8h-4a4 4 0 0 1-4-4a4 4 0 0 1 4-4"/><path fill="#00e676" d="M12 20h4v4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4"/></svg>
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M5.576 13.481a3.5 3.5 0 0 0 4.95 4.95m2.473-7.423a3.5 3.5 0 0 1 0 4.95l-2.475 2.475m-2.475-7.425l-2.475 2.475m12.857-2.957a3.5 3.5 0 1 0-4.95-4.95M11.01 13a3.5 3.5 0 0 1 0-4.95l2.474-2.475M15.958 13l2.475-2.475"
                              stroke-width="1.5"
                            />
                          </svg> */}
                        </a>
                      )}

                      {p?.dribble && (
                        <a
                          href={p?.dribble}
                          target="_blank"
                          className="md:px-6 px-[10px] py-2.5 rounded-xl inline-block  bg-white/60 text-white hover:bg-white text-[15px] md:text-[16px] text-center hover:text-black flex gap-5 items-center justify-center"
                        >
                          <span>{p?.dribble && "Dribble Shot"}</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 14 14"
                          >
                            <g
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1"
                            >
                              <path d="M7 13.25c4 0 6.25-2.25 6.25-6.25S11 .75 7 .75S.75 3 .75 7S3 13.25 7 13.25" />
                              <path d="M1.978 11.175c2.343-2.155 4.645-3.2 6.956-3.56c1.425-.224 2.854-.187 4.297.01M.824 5.799a13.64 13.64 0 0 0 6.812-.9c1.75-.706 3.127-1.68 3.944-2.569" />
                              <path d="M4.24 1.199a13.9 13.9 0 0 1 3.396 3.7c.563.901.987 1.819 1.298 2.715c.692 1.995.82 3.885.65 5.25" />
                            </g>
                          </svg>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/*========================DESIGN PROCESS================ */}
      <section id="Process" className="md:w-[90%] w-[95%] mx-auto pb-[80px] md:pb-[120px] pt-[40px]">
        <h4 className="text-[44px] md:w-[75%] leading-[1.1] font-regular">
          Design is not just how products look, but <br className='hidden md:block' /> how it's work — here's
          <span className="SERIF"> how I approach every project</span>
        </h4>

        <div className="mt-[56px] flex flex-col md:flex-row md:gap-[8px] justify-center">
          <div className="md:w-[200px] h-[160px] border border-white/20 border-dashed flex items-center justify-center rounded-[40px] text-center ">
            <h5 className="text-[24px]">
              Discover <br /> & Define
            </h5>
          </div>
          <div className="md:w-[200px] h-[160px] border border-white/20 border-dashed flex items-center justify-center rounded-[40px] text-center mt-[16px] md:mt-[48px]">
            <h5 className="text-[24px]">
              Wireframing <br /> & User-flow
            </h5>
          </div>
          <div className="md:w-[200px] h-[160px] border border-white/20 border-dashed flex items-center justify-center rounded-[40px] text-center mt-[16px] md:mt-0">
            <h5 className="text-[24px]">
              Design <br /> Visual UI
            </h5>
          </div>
          <div className="md:w-[200px] h-[160px] border border-white/20 border-dashed flex items-center justify-center rounded-[40px] text-center mt-[16px] md:mt-[48px]">
            <h5 className="text-[24px]">
              Validate <br /> final Design
            </h5>
          </div>
          <div className="md:w-[200px] h-[160px] border border-white/20 border-dashed flex items-center justify-center rounded-[40px] text-center mt-[16px] md:mt-0">
            <h5 className="text-[24px]">
              Deliver <br /> & Iterate
            </h5>
          </div>
        </div>
      </section>
      {/*========================DESIGN PROCESS================ */}
      {/* <section id="Process" className="w-[90%] mx-auto pb-[120px] pt-[40px]">
        <h4 className="text-[44px] w-[70%] leading-[1.1] font-regular">
          Want to Hire me? 
          <span className="SERIF"> Let's Have a meeting</span>
        </h4>

  
      </section> */}

      <section
        id="Contact"
        className="md:w-[90%] w-[95%] mx-auto bg-white text-black/60 mb-[px] rounded-[20px] "
      >
        <div className="md:px-8 px-4 py-6 md:py-8 ">
          <div className="w-[100%]">
            <h5 className="text-[18px] mb-[12px]">Let's connect</h5>
            <div className="flex flex-col gap-[12px]">
              <a
                href="https://wa.me/8801314600405"
                target="_blank"
                rel="noopener noreferrer"
                className="group text-[40px] hover:text-black text-black/60"
              >
                <span className="flex justify-between">
                  WhatsApp
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    className=" text-white hidden group-hover:block p-1 bg-black h-[48px] w-[48px] rounded-full rotate-[45deg] transition-transform duration-300"
                  >
                    <path
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M12 5v14m6-8l-6-6m-6 6l6-6"
                    />
                  </svg>
                </span>
                <div className="w-full h-[1px] bg-black/10"></div>
              </a>

              
              <a
                href="https://www.linkedin.com/in/amir-hosen-339a471a4"
                target="_blank"
                rel="noopener noreferrer"
                className="group text-[40px] hover:text-black text-black/60"
              >
                <span className="flex justify-between">
                  LinkedIn
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    className=" text-white hidden group-hover:block p-1 bg-black h-[48px] w-[48px] rounded-full rotate-[45deg] transition-transform duration-300"
                  >
                    <path
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M12 5v14m6-8l-6-6m-6 6l6-6"
                    />
                  </svg>
                </span>
                <div className="w-full h-[1px] bg-black/10"></div>
              </a>
              <a
                href="https://dribbble.com/amir_hosen"
                target="_blank"
                rel="noopener noreferrer"
                className="group text-[40px] hover:text-black text-black/60"
              >
                <span className="flex justify-between">
                  Dribble
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    className=" text-white hidden group-hover:block p-1 bg-black h-[48px] w-[48px] rounded-full rotate-[45deg] transition-transform duration-300"
                  >
                    <path
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M12 5v14m6-8l-6-6m-6 6l6-6"
                    />
                  </svg>
                </span>
                <div className="w-full h-[1px] bg-black/10"></div>
              </a>
              <a
                href="mailto:amirhosen3405@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group text-[40px] hover:text-black text-black/60"
              >
                <span className="flex justify-between">
                  Email
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    className=" text-white hidden group-hover:block p-1 bg-black h-[48px] w-[48px] rounded-full rotate-[45deg] transition-transform duration-300"
                  >
                    <path
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M12 5v14m6-8l-6-6m-6 6l6-6"
                    />
                  </svg>
                </span>
                <div className="w-full h-[1px] bg-black/10"></div>
              </a>
              <a
                href="https://github.com/amiribnjaman"
                target="_blank"
                rel="noopener noreferrer"
                className="group text-[40px] hover:text-black text-black/60"
              >
                <span className="flex justify-between">
                  Github
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    className=" text-white hidden group-hover:block p-1 bg-black h-[48px] w-[48px] rounded-full rotate-[45deg] transition-transform duration-300"
                  >
                    <path
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M12 5v14m6-8l-6-6m-6 6l6-6"
                    />
                  </svg>
                </span>
                <div className="w-full h-[1px] bg-black/10"></div>
              </a>
              <a
                href="https://x.com/hosen_amir27019"
                target="_blank"
                rel="noopener noreferrer"
                className="group text-[40px] hover:text-black text-black/60"
              >
                <span className="flex justify-between">
                  X (Twitter)
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    className=" text-white hidden group-hover:block p-1 bg-black h-[48px] w-[48px] rounded-full rotate-[45deg] transition-transform duration-300"
                  >
                    <path
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M12 5v14m6-8l-6-6m-6 6l6-6"
                    />
                  </svg>
                </span>
                <div className="w-full h-[1px] bg-black/10"></div>
              </a>
              <a
                href="https://www.instagram.com/amir_hosen3405/"
                target="_blank"
                rel="noopener noreferrer"
                className="group text-[40px] hover:text-black text-black/60"
              >
                <span className="flex justify-between">
                  Instagram
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    className=" text-white hidden group-hover:block p-1 bg-black h-[48px] w-[48px] rounded-full rotate-[45deg] transition-transform duration-300"
                  >
                    <path
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M12 5v14m6-8l-6-6m-6 6l6-6"
                    />
                  </svg>
                </span>
                <div className="w-full h-[1px] bg-black/10"></div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="w-full h-[110px] md:h-[170px] overflow-hidden mt-[-25px]">
        <h2 className="md:text-[222px] text-[120px] leading-[1] font-black tracking-tighter text-center z-[-50] bg-gradient-to-b from-white to-black/30  text-transparent bg-clip-text blur-[2px]">
          @AMIR <span className='hidden md:inline-block'> HOSEN</span>
        </h2>
      </div>
    </div>
  );
}

/* ================= LETTER ANIMATION ================= */

// function AnimatedLetters({ text }) {
//   return (
//     <h1 className="text-[120px] font-semibold leading-none flex justify-center flex-wrap">
//       {text.split("").map((letter, i) => (
//         <motion.span
//           key={i}
//           initial={{ opacity: 0, y: 40 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{
//             delay: i * 0.04,
//             duration: 0.5,
//           }}
//           viewport={{ once: true }}
//         >
//           {letter === " " ? "\u00A0" : letter}
//         </motion.span>
//       ))}
//     </h1>
//   );
// }

<div className="project-container relative w-[300px] h-[200px] overflow-hidden rounded-lg">
  {/* Project Image */}
  <img
    src="path-to-your-image.jpg"
    alt="Project"
    className="w-full h-full object-cover"
  />

  {/* Overlay Description */}
  <div className="absolute inset-0 bg-black/70 text-white flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
    <p className="text-center text-lg font-medium">
      This is the project description. It appears on hover.
    </p>
  </div>
</div>
